export const SUCCESS_MESSAGE =
  '신청이 완료되었습니다. 삼성 GSAT 합격을 기원합니다.'

export const SUCCES_UPDATE_MESSAGE = '신청 정보 수정이 완료되었습니다.'

export const ERROR_AGREE_TO_PRIVACY_REQUIRED =
  '개인정보 수집/이용 및 마케팅 수신\n동의가 필요합니다.\n동의 체크를 완료 해주세요.'

export const ERROR_ALL_FIELDS_REQUIRED =
  '모든 입력란은 필수적으로 입력해야 합니다.'

export const ERROR_PHONE_NUMBER_REQUIRED = '전화번호를 입력해주세요.'
